import Highway from '@dogstudio/highway';
import createEventMap from '../modules/event-map.js';

export default class singleEventRenderer extends Highway.Renderer {
    onEnter() {
        this.mapInteractive = createEventMap('single-event-map-data', this.wrap.lastElementChild);
    }

    onLeave() {
        if (this.mapInteractive) {
            this.mapInteractive.remove();
            this.mapInteractive = null;
        }
    }
}
